import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let kejianrouter = new Router({
    routes: [
        {
            path: '/',
            name: 'ceshihome',
            component: () => import('./views/ceshihome.vue'),
            hidden: true,
            redirect: 'Home',
            children: [
                {
                    path: '/',
                    name: 'home',
                    component: () => import('./views/Home.vue')
                }, {
                    path: 'enterpriseInformation',
                    name: 'enterpriseInformation',
                    component: () => import('./views/enterpriseInformation/index.vue'),
                    // component: () => import('./views/routerView'),
                    meta: {title: '工厂'},
                },
                {
                    path: 'enterpriseInformation-details',
                    name: 'enterpriseInformation-details',
                    component: () => import('./views/enterpriseInformation/details.vue'),
                    meta: {title: '详情'},
                }, {
                    path: 'Check-inInformation',
                    name: 'Check-inInformation',
                    component: () => import('./views/Check-inInformation/index.vue'),
                    meta: {title: '人才库'},
                }, {
                    path: 'excellentEnterprisePavilion',
                    name: 'excellentEnterprisePavilion',
                    component: () => import('./views/excellentEnterprisePavilion/index.vue'),
                    // component: () => import('./views/routerView'),
                    meta: {title: '新闻'},
                    // redirect: '/excellentEnterprisePavilion/list', // 默认进入
                    /* children: [
                         {
                             path: 'list',
                             name: 'list',
                             component: () => import('./views/excellentEnterprisePavilion/index.vue'),
                             meta: {title: '列表'}
                         }, {
                             path: 'details',
                             name: 'details',
                             component: () => import('./views/excellentEnterprisePavilion/details.vue'),
                             meta: {title: '详情'}
                         },
                     ]*/
                }, {
                    path: 'exhibitionInformation',
                    name: 'exhibitionInformation',
                    component: () => import('./views/exhibitionInformation/index.vue'),
                    meta: {title: '展览会信息'},
                }, {
                    path: 'businessInformation',
                    name: 'businessInformation',
                    component: () => import('./views/businessInformation/index.vue'),
                    meta: {title: '展览会信息'},
                },
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/Login.vue')
        },
    ]
})

// 判断是否需要登录权限 以及是否登录
kejianrouter.beforeEach((to, from, next) => {
    // 判断是否需要登录权限
    if (to.matched.some(res => res.meta.requireAuth)) {
        // 判断是否登录
        if (sessionStorage.getItem('token')) {
            next()
        } else {
            // 没登录则跳转到登录界面
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    } else {
        next()
    }
})

export default kejianrouter
